export const REBATE_PROMOS = 'rebate'
export const NATURAL_NUMBER_REGEXP = /^[1-9]\d*$/
export const ALIGNMENT_SERVICE = 'wheel-alignment'

export const PROMOTION_EXPIRATION_MODAL = 'promotionExpirationModal'
export const PROMOTION_EXPIRATION_MODAL_TITLE = 'A Promotion in your cart expires before your selected appointment date.'
